(() => {
  const STORAGE_KEY = "dmc-video-lead-unlocked";

  const isUnlocked = () => {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === "1";
    } catch (e) {
      return false;
    }
  };

  const markUnlocked = () => {
    try {
      sessionStorage.setItem(STORAGE_KEY, "1");
    } catch (e) {
      /* private mode / blocked storage */
    }
  };

  const getIframe = (root) => root.querySelector(".video__player iframe, iframe.iframe");

  const unlock = (root, autoplay) => {
    const iframe = getIframe(root);
    const gate = root.querySelector(".video__gate");
    const modal = root.querySelector(".video__lead-modal");
    let src = iframe?.dataset?.embedSrc || root.dataset.embedUrl || "";

    if (autoplay && src) {
      const joiner = src.includes("?") ? "&" : "?";
      if (!/[?&]autoplay=/.test(src)) {
        src = src + joiner + "autoplay=1";
      }
    }

    if (iframe && src) {
      iframe.src = src;
    }

    if (gate) {
      gate.hidden = true;
      gate.setAttribute("aria-hidden", "true");
    }

    if (modal) {
      modal.hidden = true;
    }

    markUnlocked();
  };

  const openModal = (root) => {
    const modal = root.querySelector(".video__lead-modal");
    if (!modal) return;
    modal.hidden = false;
    const first = modal.querySelector("input:not([type='hidden'])");
    if (first) {
      setTimeout(() => first.focus(), 0);
    }
  };

  const closeModal = (root) => {
    const modal = root.querySelector(".video__lead-modal");
    if (!modal) return;
    modal.hidden = true;
  };

  const setError = (form, message) => {
    const errorEl = form.querySelector(".video__lead-error");
    if (!errorEl) return;
    if (message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    } else {
      errorEl.textContent = "";
      errorEl.hidden = true;
    }
  };

  const clearFieldErrors = (form) => {
    form.querySelectorAll("[aria-invalid]").forEach((el) => el.removeAttribute("aria-invalid"));
  };

  const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const validate = (form) => {
    clearFieldErrors(form);
    const email = form.querySelector('[name="Email"]');
    const name = form.querySelector('[name="Name"]');
    const company = form.querySelector('[name="Company"]');
    let message = "";

    if (!email?.value?.trim()) {
      email?.setAttribute("aria-invalid", "true");
      message = "Please enter your email address.";
    } else if (!isValidEmail(email.value.trim())) {
      email?.setAttribute("aria-invalid", "true");
      message = "Please enter a valid email address.";
    }

    if (!name?.value?.trim()) {
      name?.setAttribute("aria-invalid", "true");
      if (!message) message = "Please enter your name.";
    }

    if (!company?.value?.trim()) {
      company?.setAttribute("aria-invalid", "true");
      if (!message) message = "Please enter your company.";
    }

    const website = form.querySelector('[name="Website"]');
    if (website?.value?.trim()) {
      try {
        // Allow values without protocol by attempting URL parse with https prefix
        const raw = website.value.trim();
        // eslint-disable-next-line no-new
        new URL(raw.includes("://") ? raw : `https://${raw}`);
      } catch (e) {
        website.setAttribute("aria-invalid", "true");
        if (!message) message = "Please enter a valid website URL.";
      }
    }

    setError(form, message);
    return !message;
  };

  const stripPageTitleSuffix = (title) => {
    const separator = " | ";
    const index = title.lastIndexOf(separator);
    return index > 0 ? title.substring(0, index).trim() : title.trim();
  };

  const submit = async (root, form) => {
    if (!validate(form)) return;

    const pageUrlInput = form.querySelector("[data-page-url]");
    if (pageUrlInput) {
      pageUrlInput.value = window.location.href;
    }

    const pageTitleInput = form.querySelector("[data-page-title]");
    if (pageTitleInput && !pageTitleInput.value?.trim()) {
      pageTitleInput.value = stripPageTitleSuffix(document.title || "");
    }

    const submitBtn = form.querySelector(".video__lead-submit");
    if (submitBtn) submitBtn.disabled = true;
    setError(form, "");

    const url = root.dataset.submitUrl || "/VideoLeadCapture/Submit";
    const body = new URLSearchParams(new FormData(form));

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Accept: "application/json",
        },
        body,
      });

      let payload = null;
      try {
        payload = await response.json();
      } catch (e) {
        payload = null;
      }

      if (!response.ok || payload?.success === false) {
        setError(form, payload?.message || "Unable to submit. Please try again.");
        return;
      }

      unlock(root, true);
    } catch (e) {
      setError(form, "Unable to submit. Please try again.");
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  };

  const init = (root) => {
    if (isUnlocked()) {
      unlock(root, false);
      return;
    }

    const gateButton = root.querySelector(".video__gate-button");
    const closeButton = root.querySelector(".video__lead-close");
    const form = root.querySelector(".video__lead-form");
    const modal = root.querySelector(".video__lead-modal");

    gateButton?.addEventListener("click", () => openModal(root));
    closeButton?.addEventListener("click", () => closeModal(root));

    modal?.addEventListener("click", (e) => {
      if (e.target === modal) {
        closeModal(root);
      }
    });

    form?.addEventListener("submit", (e) => {
      e.preventDefault();
      submit(root, form);
    });

    root.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && modal && !modal.hidden) {
        closeModal(root);
      }
    });
  };

  const boot = () => {
    document.querySelectorAll("[data-video-lead='true']").forEach(init);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
